module.exports = function(chain, options = {}) {
  return chain.invoke('createTree')
}


// WEBPACK FOOTER //
// ./src/selectors/document/tree.js